<template>
  <div  :class="['ticket-container', ticketLoader ? 'hidden' : '']">
    <paginaRingraziamento
      v-if="showPaginaRingraziamento"
      :paginaRingraziamentoLogId="paginaRingraziamentoLogId"
      :setPaginaLoaderCallback="setPaginaLoaderCallback"
      :ticketId="ticketIdCreato"
    >
    </paginaRingraziamento>
    <template v-if="answerDetail?.article_content?.length > 0 && !showPaginaRingraziamento">
      <div v-for="(article) in answerDetail?.article_content" :key="article.id" >
        <articleContent :html_content="article.template" />
      </div>
    </template>
    <form
      v-if="showTicketForm && !showOnlyTagArticle"
      class="row g-3 needs-validation text-start"
      @submit="checkForm"
      id="ticket-form-create"
      :novalidate="novalidate"
    >
      <div class="titolo-form-ticket-container">
        <h1> {{ answerDetail?.answerAreaAsoc && answerDetail?.answerAreaAsoc[0]?.id_area == 6 ? 'Compila i campi sottostanti' : 'Compila i campi sottostanti in modo da essere ricontattato:' }}</h1>
        <p>
          <strong>IMPORTANTE</strong>: si informa che ai fini di
          una efficiente gestione del servizio si darà risposta
          in via prioritaria ai quesiti posti in modo esaustivo.
        </p>
      </div>
      <ticketFormInputs
        ref="ticketFormInputs"
        :answerDetail="answerDetail"
      ></ticketFormInputs>
      <fileUploaderList
        v-if="uploadEnabled"
        ref="fileListUploader"
        :answerDetail="answerDetail"
        :ticketId="ticketIdCreato"
      />
      <div class="col-12 fw-bold">
        {{ intl[$store.state.lang]["privacy"] }}
        <span style="font-weight: bold"> <a style="color: #008c95" href="https://www.organismo-am.it/documenti/OAM-Informativa_di_base.pdf" target="_blank">Privacy</a></span
        ><span style="font-weight: bold">*:</span>
      </div>
      <div class="col-12">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            id="validationToc"
            aria-describedby="invalidToc"
            v-model="toc"
            required
          />
          <label class="form-check-label" for="validationToc" v-html="terms">
          </label>
          <div id="invalidToc" class="invalid-feedback">
            {{ intl[$store.state.lang]["terms-and-conditions-not-ok"] }}
          </div>
        </div>
      </div>

      <!-- <div id="dynamic_recaptcha_1" class="g-recaptcha" data-sitekey="6Lf9ZRUTAAAAACEhXSnlIrYUm5Uaq4sdyL27TKUp" data-theme="light" data-size="normal"></div> -->
      <recaptchaContainer
          ref="recaptchaRef"
          style="margin-top: 20px"
          :recaptchaCallback="recaptchaCallback"
        />

      <div class="col-12">
        <button
          class="btn btn-primary"
          :disabled="!this.toc"
          type="submit"
          style="
            background-color: #008c95;
            border-color: #008c95;
            background-image: unset;
          "
        >
          {{ intl[$store.state.lang]["submit-request"] }}
        </button>
      </div>
      <span style="font-size: 14px; margin-top: 10px">
        {{ intl[$store.state.lang]["required-fields"] }}</span
      >
      <span v-if="!isTerminaleAmministrativo" style="font-size: 14px; margin-top: 10px">
        {{ intl[$store.state.lang]["required-fields-telephone"] }}</span
      >
      <span v-if="isTerminaleAmministrativo" style="font-size: 14px; margin-top: 10px">
        {{ intl[$store.state.lang]["required-fields-pivacodfis"] }} <br>  {{ intl[$store.state.lang]["required-fields-nsr"] }} </span
      >
    </form>
    <div
      v-if="showErrorAlert"
      class="alert alert-danger mt-5"
      role="alert"
      style="font-size: 16px"
    >
      Si è verificato un errore durante la creazione del ticket. Riprova più
      tardi.
    </div>
  </div>
</template>

<script>
import intl from "./intl/intl";
import { apiUrls } from "../../api/apiUrls";
import axios from "axios";
import { MD5 } from 'crypto-js';
import PaginaRingraziamento from "../paginaRingraziamento/PaginaRingraziamento.vue";
import TicketFormInputs from "../ticketFormInputs/TicketFormInputs.vue";
import FileUploaderList from "../fileUploaderList/FileUploaderList.vue";
import RecaptchaContainer from "../recaptchaContainer/RecaptchaContainer.vue";
import ArticleContent from "../articleContent/ArticleContent.vue";
export default {
  name: "ticket",
  components: {
    paginaRingraziamento: PaginaRingraziamento,
    ticketFormInputs: TicketFormInputs,
    fileUploaderList: FileUploaderList,
    articleContent: ArticleContent,
    recaptchaContainer: RecaptchaContainer
  },
  mounted() {},
  props: {
    surveyId: {
      type: Number,
      default: null,
    },
    answerId: {
      type: Number,
      default: null,
    },
    getPaginaRingraziamentoCallback: {
      type: Function,
      default: (value) => {
        console.log("Pagina ringraziamento show: ", value);
      },
    },
    includiPaginaRingraziamento: {
      type: Boolean,
      default: true,
    },
    novalidate: {
      type: Boolean,
      default: true,
    },
    setPaginaLoaderCallback: {
      type: Function,
      default: (value) => {
        return
      },
    },
    onCreateTicketCallback: {
      type: Function,
      default: (response) => {
        //console.log("Info ticket creato: ", response);
        return
      },
    },
    staticAnswerShowInput: {
      type: Boolean,
      default: false,
    },
    staticAnswerShowInputElements: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.addFormEventListener();
    this.getAnswerDetail();


  },
  beforeUnmount() {
    this.removeFormEventListener();
  },
  data: function () {
    return {
      intl: intl,
      toc: false,
      ticketLoader: false,
      showErrorAlert: false,
      ticketIdCreato: null,
      paginaRingraziamentoLogId: null,
      answerDetail: null,
      recaptchaWidgetId: null,
      siteKey: process.env.VUE_APP_RECAPTCHA_SITEKEY,
      terms:
        'Autorizzo il trattamento dei miei dati personali ai sensi del D.Lgs. 196/2003 e all’art. 13 GDPR 679/16.',
      recaptchaError: false,
      isTerminaleAmministrativo: false,
      attachmentsEnabled: false
    };
  },
  methods: {
    decodeHtml(html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },

    addFileAndTypesToFormdata(fd, fileAndTypes) {
      fileAndTypes.map((f) => {
        if (f.file && f.type) {
          fd.append("file[]", f.file);
          fd.append("type[]", f.type);
        }
      });
    },
    prepareDefaultAssistenzaPayload(inputParams){
      const fd = new FormData();
      let telefon = inputParams["telefon"];
      let mobile = inputParams["mobile"];
      let firstName = inputParams["name"];
      let lastName = inputParams["surname"];
      let contact_times = inputParams["contact_times"];
      let email = inputParams["email"];
      let pec_peo = inputParams["pec_peo"];
      let active = inputParams['active'];
      let question = inputParams["question"];
      let id_survey = localStorage.getItem( this.$store.state.libraryWiperConfig.lastSurveyLocalstorageId)
      let activation_code = MD5(inputParams['name'] + ':' + inputParams['telefon'] + ':' + id_survey).toString()
      let area = 2
      if (this.answerDetail?.answerAreaAsoc[0]?.id_area) {
        area =  this.answerDetail?.answerAreaAsoc[0]?.id_area;
      }
      fd.append("active", active == 1 ? "1" : "0");
      email && fd.append("email", email);
      pec_peo && fd.append("pec_peo", pec_peo);
      contact_times && fd.append("contact_times", contact_times);
      activation_code && fd.append("activation_code", activation_code);
      firstName && fd.append("name", firstName);
      lastName && fd.append("surname", lastName);
      telefon && fd.append("telefon", telefon);
      mobile && fd.append("mobile", mobile);
      question && fd.append("question", question);
      id_survey && fd.append("id_survey", id_survey);
      fd.append("status", 0);
      fd.append("survey_ok", "0");
      fd.append("area", area);
      //attualmente non ci sono mai allegati per i terminali assistenza
      this.addAttachmentsToFormData(fd)
      return fd


    },
    prepareAmministrativoPayload(inputParams){
      const fd = new FormData();
      let mobile = inputParams["mobile"];
      let firstName = inputParams["name"] || 'N.D.';
      let lastName = inputParams["surname"] || 'N.D.';
      let active = inputParams['active'];
      let ragione_sociale =  inputParams['ragione_sociale'];
      let importo_richiesto =  inputParams['importo_richiesto'];
      let importo_ricevuta =  inputParams['importo_ricevuta'];
      let iban =  inputParams['iban'];
      let intestatario =  inputParams['intestatario'];
      let bic_swift =  inputParams['bic_swift'];
      let data_bonifico =  inputParams['data_bonifico'];
      let data_pagamento =  inputParams['data_pagamento'];
      let codfisc = inputParams['codfisc'];
      let piva = inputParams['piva'];
      let email = inputParams['email'] ? inputParams['email'] : 'nd@nd.it';
      let pec_peo = inputParams['pec_peo'] == 0 ? inputParams['pec_peo'] : 1;
      let question = "";
      //il campo question può cambiare label a seconda dell area. Per assistenza sarà mappato con question. Per assistenza amministrativo con question_amm. Per un futuro altro uffixio X question_X
      let questionKey = Object.keys(inputParams).find(key => key.startsWith("question_"));
      if (questionKey) {
        question = inputParams[questionKey];
      }
      let id_survey = localStorage.getItem( this.$store.state.libraryWiperConfig.lastSurveyLocalstorageId)
      let activation_code = MD5(inputParams['name'] + ':' + inputParams['telefon'] + ':' + id_survey).toString()
      //Per assistrenza di default l area è 2. Se la risposta terminale è mappata in answer_area_asoc invece prenderà l area ritornata dall api
      let area = this.$store.state["libraryWiperConfig"].ufficioAmministrativoId 
      fd.append("active", active == 1 ? "1" : "0");
      ragione_sociale && fd.append("ragione_sociale", ragione_sociale);
      activation_code && fd.append("activation_code", activation_code);
      firstName && fd.append("name", firstName);
      lastName && fd.append("surname", lastName);
      mobile && fd.append("mobile", mobile);
      question ? fd.append("question", question) : fd.append("question", 'n.d.');
      id_survey && fd.append("id_survey", id_survey);
      piva && fd.append("piva", piva);
      codfisc && fd.append("codfisc", codfisc);
      importo_richiesto ? fd.append("importo_richiesto", importo_richiesto) : fd.append("importo_richiesto", '');
      importo_ricevuta ? fd.append("importo_ricevuta", importo_ricevuta) :  fd.append("importo_ricevuta", '') ;
      iban ? fd.append("IBAN", iban) : fd.append("IBAN", '');
      intestatario && fd.append("intestatario", intestatario);
      bic_swift && fd.append("BIC_SWIFT", bic_swift);
      data_bonifico ? fd.append("data_bonifico", data_bonifico) : fd.append("data_bonifico", '');
      data_pagamento ? fd.append("data_pagamento", data_pagamento) : fd.append("data_pagamento", '') ;
      fd.append("status", 0);
      fd.append("survey_ok", "0");
      fd.append("area", area);
      fd.append("email", email);
      fd.append("pec_peo", pec_peo);
      this.addAttachmentsToFormData(fd)
      return fd
      
    },
    addAttachmentsToFormData(fd){
      if(this.uploadEnabled){
        if (this.$refs.fileListUploader?.getFilesAndTypes) {
          let fileAndTypes = this.$refs.fileListUploader.getFilesAndTypes();
          if (fileAndTypes?.length > 0) {
            this.addFileAndTypesToFormdata(fd, fileAndTypes);
          }
        }
      }
    },

    mapInputParamsToTicketPayload(inputParams) {
      let area = 2
      if (this.answerDetail?.answerAreaAsoc[0]?.id_area) {
        area =  this.answerDetail?.answerAreaAsoc[0]?.id_area;
      }
      if(this.answerDetail?.answerShowInput?.some(obj => obj.name === "active"  && obj.required == 1)){
        inputParams['active'] = 1
      }else{
        inputParams['active'] = 0
      }

      if(area == this.$store.state["libraryWiperConfig"].ufficioAmministrativoId){
        return this.prepareAmministrativoPayload(inputParams)
      }else{
        return this.prepareDefaultAssistenzaPayload(inputParams)
      }
    },

    recaptchaCallback(response) {
      //console.log("reCAPTCHA response:", response);
      return
    },

    async checkForm(e) {
      if (e) e.preventDefault();
      var forms = document.querySelectorAll(
        ".ticket-container .needs-validation"
      );
      Array.prototype.slice.call(forms).forEach(function (form) {
        form.classList.add("was-validated");
      });
      this.recaptchaError = false;
      this.showErrorAlert = false;
      let responseCaptcha = null;
      

        if (this.$refs["recaptchaRef"]) {
          responseCaptcha = await this.$refs["recaptchaRef"].executeRecaptcha();
        }
      if (responseCaptcha.length === 0) {
        this.recaptchaError = true;
      }
      let lastSurveyLocalstorage = localStorage.getItem(this.$store.state.libraryWiperConfig.lastSurveyLocalstorageId)
      if(!lastSurveyLocalstorage && this.paginaRingraziamentoLogId){
        lastSurveyLocalstorage = this.paginaRingraziamentoLogId
      }
      let canCreateTicket = lastSurveyLocalstorage && this.$refs["ticketFormInputs"].inputOblligatoriOk() && !this.recaptchaError
      
      if(this.uploadEnabled){
        this.$refs?.fileListUploader?.checkAttachmentsOnCreateTicket();
        this.$refs["ticketFormInputs"]?.checkFormInputsMessages();
        canCreateTicket = canCreateTicket && this.$refs.fileListUploader.fileObbligatoriDaCaricare().length === 0 && !this.$refs.fileListUploader.esisteUnFileNonCoerente()
      }
      

      
        
     
      if (canCreateTicket) {
        this.ticketLoader = true;
        let inputParams = this.$refs["ticketFormInputs"].getInputParams()
        let formData = this.mapInputParamsToTicketPayload(inputParams);

       
        this.paginaRingraziamentoLogId = localStorage.getItem(
              this.$store.state.libraryWiperConfig.lastSurveyLocalstorageId
            );
        localStorage.removeItem(
          this.$store.state.libraryWiperConfig.lastSurveyLocalstorageId
        );
        axios
          .post(apiUrls["create_ticket"], formData)
          .then((response) => {
            

            if (response.data) {
              this.onCreateTicketCallback(response);
            }
            this.ticketIdCreato = response.data.id;
            this.ticketLoader = false;

           
            if (this.$store.hasModule("questionarioStore-" + this.surveyId)) {
              this.$store.commit(
                "questionarioStore-" + this.surveyId + "/doCloseQuiz"
              );
            }
          })
          .catch((error) => {
            this.ticketLoader = false;
            this.showErrorAlert = true;
          });
      }
    },
    addFormEventListener() {
      var forms = document.querySelectorAll(
        ".ticket-container .needs-validation"
      );
      Array.prototype.slice.call(forms).forEach(function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            form.classList.add("was-validated");
            if (!form.checkValidity()) {
              event.preventDefault();
              event.stopPropagation();
            } else {
            }
            
          },
          false
        );
      });
    },
    getAnswerDetail() {
      if (this.answerId) {
        this.ticketLoader = true;

        axios
          .get(apiUrls["answer_detail"] + this.answerId)
          .then((response) => {
            if (response.data) {
              this.answerDetail = response.data;
              this.checkAttachmentsEnabled()
              //IN WIPER ASSISTENZAN ON ESISTE LA TABELLA ANDWERSHOWINPUT QUINDI HO AGGIUNTO UNA CONFIGURAZIONE STATICA
              //VIENE PASSATA DAL COMPONENTE PAGINAQUESTIONARIO E CONTIENE UN EVENTUALE VALORE DI DEFAULT PER LA TEXTAREA 'DOMANDA'
              //con gli sviluppi di wiper amministrativo ci saranno risposte che avranno delle occorrenza in answershowinput. Per queste nuove risposte si deve attingere da li
              let isTerminaleAmministrativo = false
                this.answerDetail.answerAreaAsoc.map((area) => {
                  if(area.id_area == this.$store.state["libraryWiperConfig"].ufficioAmministrativoId){
                    isTerminaleAmministrativo = true
                  }
                  
                  

                })
              if (
                this.staticAnswerShowInput &&
                (!response.data.answerShowInput || response.data.answerShowInput?.length === 0)
              ) {
               
                if(!isTerminaleAmministrativo){
                  this.answerDetail.answerShowInput = this.staticAnswerShowInputElements;
                }else{
                  this.isTerminaleAmministrativo = true
                }
                
              } else {
                if(!isTerminaleAmministrativo){
                  this.answerDetail.answerShowInput = this.staticAnswerShowInputElements;
                }else{
                  this.isTerminaleAmministrativo = true
                }
                this.answerDetail.answerShowInput = this.handleAnswerShowInputResponse(response.data.answerShowInput)
              }
            }


            this.ticketLoader = false;
          })
          .catch((error) => {
            this.ticketLoader = false;
          });
      }
    },
    checkAttachmentsEnabled(){
      this.answerDetail.answerAreaAsoc.map((area) => {
        if(!this.attachmentsEnabled && this.answerDetail.attachmentsEnabled){
          this.attachmentsEnabled = this.answerDetail.attachmentsEnabled.some(obj => obj.id_area === area.id_area && obj.enabled == 1);
        }
      })
    },
    handleAnswerShowInputResponse(answerShowInput){
      //DA GESTIRE LATO BACKEND ORDINAMENTO EVENTUALE ANSWERSHOWINPUT
      //nel caso in cui ci sia bisogno di gestire l ordine delle input nella form attualmente bisogna ordinarle correttamente nella tabella, quindi fare uno script che cancella tutte le answershowinput per una data risposta e le reinserisce nell ordine corretto
      //gestire lato FE si potrebbe fare per area (con un metodo che per are imposti un ordine statico) ma nel caso in cui ogni risposta debba avere un ordine suo non sarebbe sufficiente. Servirebbe aggiungere una colonna di ordinamento nella answer_show_input
      let actualAnswerShowInput = []
      let ibanInputInfos = {}
      let ibanPosition = null
      answerShowInput.map((input,i) => {
        if(input.name === "iban"){
          ibanPosition = i
          ibanInputInfos.showIban = true
          ibanInputInfos.ibanRequired = input.required
        }else if(input.name === "intestatario"){
          ibanInputInfos.showIntestatario = true
          ibanInputInfos.intestatarioRequired = input.required
        }else if(input.name === "bic_swift"){
          ibanInputInfos.showBicswift = true
          ibanInputInfos.required = false
        }else{
          actualAnswerShowInput.push(input)
        }
      })
      if(Object.keys(ibanInputInfos).length > 0){
        ibanInputInfos.name = "iban_input"
        actualAnswerShowInput.splice(ibanPosition,0,ibanInputInfos)
      }
      return actualAnswerShowInput
    },
    

    removeFormEventListener() {
      var forms = document.querySelectorAll(
        ".ticket-container .needs-validation"
      );
      Array.prototype.slice.call(forms).forEach(function (form) {
        form.removeEventListener(
          "submit",
          function (event) {
            if (!form.checkValidity()) {
              event.preventDefault();
              event.stopPropagation();
            }

            form.classList.add("was-validated");
          },
          false
        );
      });
    },
  },
  watch: {
    ticketLoader: {
      handler: function (newValue, oldValue) {
        if (oldValue !== newValue) {
          this.setPaginaLoaderCallback({ ticketLoader: newValue });
        }
      },
      deep: true,
    },
  },
  computed: {
    showOnlyTagArticle: function () {
      return this.isTerminaleAmministrativo && this.answerDetail?.answerShowInput?.length === 0
    },
    uploadEnabled: function () {
      return  this.$store.state.libraryWiperConfig.enableAllegati?.toLowerCase() === "true" && this.attachmentsEnabled === true
    },
    showPaginaRingraziamento: function () {
      this.getPaginaRingraziamentoCallback(
        this.includiPaginaRingraziamento && this.ticketIdCreato !== null
      );
      return this.includiPaginaRingraziamento && this.ticketIdCreato !== null;
    },
    showTicketForm: function () {
      return (
        !this.includiPaginaRingraziamento ||
        (this.includiPaginaRingraziamento && this.ticketIdCreato === null)
      );
    },
  },
};
</script>
